import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import MeasurementList from './MeasurementList';

const Measurements = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '#', label: 'Parámetros Ambientales', icon: 'icon-thermometer-sun' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Mediciones' links={breadcrumbLinks} icon={'icon-database'} />
					<MeasurementList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Measurements;
